import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import img1 from "../../assets/images/cart/img1.png";
import img2 from "../../assets/images/cart/img2.png";
import img3 from "../../assets/images/cart/img3.png";
import img4 from "../../assets/images/cart/img4.png";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { Mail } from "../../components/Mailbox";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import orderImg from "../../assets/images/cart/orderConfirm.png";
import { borderRadius, height } from "@mui/system";
import { Link } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

export function Checkout() {
  const [cartproducts, setcartProduct] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setcartProduct(cartproduct);
  }, []);

  var cartproduct = [
    {
      image: img1,
      name: "Classic Leather Shoes",
      subname: "EcoStep Shoes",
      price: 1200,
    },
    {
      image: img2,
      name: "Vintage Gold Locket",
      subname: "VintageVogue Jewelry",
      price: 40000,
    },
    {
      image: img3,
      name: "Radiant Silk Dress",
      subname: "RadiantRose Bridal",
      price: 8000,
    },
    {
      image: img4,
      name: "Stylish Ankle Boots",
      subname: "StyleTread Boots",
      price: 800,
    },
  ];

  return (
    <div className="HomeMainContainer container">
      <div className="account-title">SHOPPING CART</div>
      <Breadcrumb className="custom-breadcrumb">
        <Breadcrumb.Item href="/">HOME</Breadcrumb.Item>
        <Breadcrumb.Item href="/cart">SHOPPING CART</Breadcrumb.Item>
        <Breadcrumb.Item href="/checkout">CHECKOUT</Breadcrumb.Item>
      </Breadcrumb>
      <div className="checkout-subcontainer">
        <div className="contactDetails-container">
          <div className="contactDetails-title">Contact Details</div>
          <div className="contactDetails-subcontainer">
            <div className="contactDetails-left">
              <div className="contact-field">
                <label>First Name</label>
                <div>
                  <input type="text" placeholder="Enter your First Name" />
                </div>
              </div>
              <div className="contact-field">
                <label>Email Address</label>
                <div>
                  <input type="text" placeholder="Enter your email address" />
                </div>
              </div>
            </div>
            <div className="contactDetails-right">
              <div className="contact-field">
                <label>Last Name</label>
                <div>
                  <input type="text" placeholder="Enter your Last Name" />
                </div>
              </div>
              <div className="contact-field">
                <label>Phone Number</label>
                <div>
                  <input type="text" placeholder="Enter your phone number" />
                </div>
              </div>
            </div>
          </div>

          <div className="contactDetails-title">Shipping Details</div>
          <div className="contactDetails-subcontainer">
            <div className="contactDetails-left">
              <div className="contact-field">
                <label>Street</label>
                <div>
                  <input type="text" placeholder="Enter address" />
                </div>
              </div>
              <div className="contact-field">
                <label>State</label>
                <div>
                  <select>
                    <option disabled>Select</option>
                    <option>Telangana</option>
                    <option>Andhra Pradesh</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="contactDetails-right">
              <div className="contact-field">
                <label>City</label>
                <div>
                  <input type="text" placeholder="Enter your city" />
                </div>
              </div>
              <div className="contact-field">
                <label>Pin Code</label>
                <div>
                  <input type="text" placeholder="Enter your phone number" />
                </div>
              </div>
            </div>
          </div>

          <div className="contactDetails-title">Payment Mode</div>
          <div className="contactDetails-subcontainer">
            <div className="contactDetails-left">
              <div className="contactDetails-radio">
                <input type="radio" name="payment" />
                <label>Cash On Delivery</label>
              </div>
              <div className="contactDetails-radio">
                <input type="radio" name="payment" />
                <label>Credit Card</label>
              </div>
            </div>
            <div className="contactDetails-right">
              <div className="contactDetails-radio">
                <input type="radio" name="payment" />
                <label>UPI</label>
              </div>
              <div className="contactDetails-radio">
                <input type="radio" name="payment" />
                <label>Debit Card</label>
              </div>
            </div>
          </div>
          <div className="cards-container">
            <div>
              <input type="text" placeholder="Card Number" />
            </div>
            <div className="cards-subcontainer">
              <div>
                <label> Expiry Date</label>
                <input type="date" />
              </div>
              <div>
                <label>CVV</label>
                <input type="text" placeholder="cvv" />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="contactDetails-title">Your Order</div>
          <div>
            {cartproducts.map((product) => (
              <div className="yourOrder-container">
                <div>
                  <img src={product.image} />
                </div>
                <div>
                  <div className="product-name">{product.name}</div>
                  <div className="product-subname">{product.subname}</div>
                  <div className="product-prices">₹ {product.price}</div>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {" "}
                  <span>- 1 +</span>
                  <span>
                    <IoIosCloseCircleOutline />
                  </span>
                </div>
              </div>
            ))}
          </div>
          <div className="checkoutorder-summary">
            <div className="order-list">
              <div>Total Items</div>
              <div>4</div>
            </div>
            <div className="order-list">
              <div>Sub Total</div>
              <div>₹50000.00</div>
            </div>
            <div className="order-list">
              <div>Shipping</div>
              <div>₹100.00</div>
            </div>
            <div className="order-list">
              <div>Taxes</div>
              <div>₹0.00</div>
            </div>
            <div className="order-list">
              <div>Discount</div>
              <div className="text-success">₹1000.00</div>
            </div>
            <div className="productTotal">
              <div>Total</div>
              <div>₹49100.00</div>
            </div>
            {/* <div className="btnPayment">
              <button>Make Payment</button>
            </div> */}
            <div>
              <Button onClick={handleOpen} className="btnPayment">
                Make Payment
              </Button>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} className="modal-container">
                  <div className="modalImg">
                    <img src={orderImg} />
                  </div>
                  <div
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <div className="modal-content">
                      <div className="modal-orderText">Order Confirmed!</div>
                      <div className="modal-orderDesc">
                        Thank you for shopping with us. Your order is on its
                        way!
                      </div>
                      <div>
                        <Link to="/">
                          {" "}
                          <Button className="btnGo">Go Back to Homepage</Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </Box>
              </Modal>
            </div>
          </div>
        </div>
      </div>
      <Mail />
    </div>
  );
}
